import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyJsdReportsCustomRoute: InvariantJiraRoute = {
	name: 'legacy-jsd-reports-custom',
	path: '/projects/:projectKey/reports/custom/:id?',
};
